import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class HttpClient {
  private axios: AxiosInstance;
  constructor({ baseUrl }: { baseUrl: string }) {
    this.axios = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
    });
  }

  public get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.get(url, options);
  }

  public put(url: string, data?: any, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.put(url, data, options);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/infrastructure/adapter/HttpClient.ts